import { Navigate, Route, Routes } from "react-router-dom";
import { ToastProvider } from "../../ui";
import OwnerShell from "./OwnerShell";
import OwnerLogin from "./OwnerLogin";
import OwnerClubs from "./OwnerClubs";
import OwnerBilling from "./OwnerBilling";
import OwnerPayments from "./OwnerPayments";
import OwnerProfile from "./OwnerProfile";
import OwnerSupport from "./OwnerSupport";

export default function OwnerCabinet() {
  return (
    <ToastProvider>
      <Routes>
        <Route path="login" element={<OwnerLogin />} />
        <Route element={<OwnerShell />}>
          <Route index element={<Navigate to="clubs" replace />} />
          <Route path="clubs" element={<OwnerClubs />} />
          <Route path="billing" element={<OwnerBilling />} />
          <Route path="payments" element={<OwnerPayments />} />
          <Route path="support" element={<OwnerSupport />} />
          <Route path="profile" element={<OwnerProfile />} />
        </Route>
        <Route path="*" element={<Navigate to="/account" replace />} />
      </Routes>
    </ToastProvider>
  );
}
